import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, FreeMode, Scrollbar } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/free-mode";
import "swiper/css/scrollbar";

import "./Gallery_Inner.css";
import { FaMapMarkerAlt, FaTimes } from "react-icons/fa";

import { GalleryById } from "../../../utils/apis/gallery/Gallery";
import { IDS } from "../../../utils/common";

const GalleryInner = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  const HtmlToReactParser = require("html-to-react").Parser;
  const htmlToReactParser = new HtmlToReactParser();

  const [images, setImages] = useState([]);
  const [gallery, setGallery] = useState({});

  const getGallery = async () => {
    const res = await GalleryById(id);

    if (res?.success) {
      setGallery(res?.data || {});
      setImages(res?.data?.gallery_images || []);
    }
  };

  useEffect(() => {
    if (id) {
      getGallery();
    }
  }, [id]);

  const handleClose = () => {
    navigate("/gallery");
  };

  return (
    <div className="custom_container">
      <div className="row me-0 ms-0">
        <div className="col-md-7">
          <div className="gallery-wrapper ">
            {/* THUMBNAILS */}
            <aside className="gallery-aside">
              <Swiper
                onSwiper={setThumbsSwiper}
                direction="vertical"
                slidesPerView={5}
                spaceBetween={12}
                freeMode={true}
                watchSlidesProgress={true}
                modules={[FreeMode, Scrollbar]}
                breakpoints={{
                  0: { direction: "horizontal", slidesPerView: 4 },
                  768: { direction: "vertical", slidesPerView: 5 },
                }}
                className="gallery-thumbs"
              >
                {images.map((img) => (
                  <SwiperSlide key={img.id}>
                    <img src={IDS?.IMG_URL + img.url} alt="thumb" />
                  </SwiperSlide>
                ))}
              </Swiper>
            </aside>

            {/* MAIN SLIDER */}
            <Swiper
              spaceBetween={10}
              loop={true}
              navigation={true}
              thumbs={{
                swiper:
                  thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
              }}
              modules={[Navigation, Thumbs]}
              className="gallery-main"
            >
              {images.map((img) => (
                <SwiperSlide key={img.id}>
                  <div className="thumb_main_div">
                    <img src={IDS?.IMG_URL + img.url} alt="main" />
                  </div>
                </SwiperSlide>
              ))}

              <button
                className="close-btn"
                onClick={handleClose}
                aria-label="Close gallery"
              >
                <FaTimes />
              </button>
            </Swiper>
          </div>
        </div>
        <div className="col-md-5">
          {/* OVERLAY */}
          <div className="gallery-overlay">
            <div className="location">
              <FaMapMarkerAlt />
              <span>{gallery?.name}</span>
            </div>

            <p>{htmlToReactParser.parse(gallery?.description)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryInner;
